import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapSplitButton = React.lazy(function () {
    return import('../../bootstrap-components/components/BTMenuButton');
});
var bootStrapSplitButton = function (props) {
    return (React.createElement(BootStrapSplitButton, __assign({}, props)));
};
var SplitButton = function (props) {
    var componentToDisplay = bootStrapSplitButton(props);
    switch (props.ioTheme.uiLibrary) {
        case 'materialui':
            componentToDisplay = bootStrapSplitButton(props);
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) },
            " ",
            componentToDisplay,
            " ")));
};
SplitButton.defaultProps = {
    styleName: 'primary',
    menuLabel: 'ButtonTest',
    ioTheme: themes[0],
    ioMode: 'light'
};
export default React.memo(SplitButton);
//# sourceMappingURL=SplitButton.js.map